import { IGiaItem } from 'api/types';
import { CompulsoryGiaSubjects, GiaCategory, GiaCategoryKeys } from 'const';
import { format } from 'date-fns';
import { checkPassedExamDate, getExamDoughnutData, getMark } from 'utils';

const useGiaExamCardProperties = (exam: IGiaItem) => {
  const {
    name,
    formaGia,
    approbation,
    primaryMarkValue,
    primaryMarkBasis,
    normalizedMarkValue,
    normalizedMarkBasis,
    positiveResultThreshold,
    date,
    isCredit,
    percentMarkValue,
    examResult,
  } = exam;

  // категория
  let category: GiaCategoryKeys = GiaCategoryKeys.OPTIONALLY;
  let categoryName: string | null = GiaCategory.optionally;

  if (name && CompulsoryGiaSubjects.includes(name)) {
    category = GiaCategoryKeys.COMPULSORY;
    categoryName = GiaCategory.compulsory;
  }

  //набранные быллы
  const maxBalls = primaryMarkBasis;
  const currentBalls = primaryMarkValue;

  const { doughnutTotal, doughnutData, doughnutColor, lowerHint } = getExamDoughnutData({
    formaGia,
    approbation,
    normalizedMarkValue,
    normalizedMarkBasis,
    percentMarkValue,
    positiveResultThreshold,
    isCredit,
  });

  // оценка
  const mark = !normalizedMarkValue ? 'Пока не сдан' : getMark(Number(primaryMarkValue), Number(primaryMarkBasis));

  // дата
  const examDate = new Date(date);
  const passingYear = date.slice(0, 4);
  const resultDate = checkPassedExamDate(examDate)
    ? `Проведен ${format(new Date(date), 'dd.MM.yyyy')}`
    : `Будет сдан в ${passingYear} г.`;

  // сли форма зачета, то всегда обязательный
  if (isCredit) {
    category = GiaCategoryKeys.COMPULSORY;
    categoryName = GiaCategory.compulsory;
  }

  return {
    category,
    categoryName,
    doughnutTotal,
    doughnutData,
    doughnutColor,
    mark,
    resultDate,
    maxBalls,
    currentBalls,
    lowerHint,
    isCredit,
    url: examResult?.url,
  };
};

export default useGiaExamCardProperties;
